import * as React from "react";
import { useTranslation } from "react-i18next";
import { LineChart as MUILineChart } from "@mui/x-charts/LineChart";
import { legendClasses } from "@mui/x-charts";

export interface LinearChartSeries {
  label: string;
  data: number[];
  color: string;
}

export interface LineChartProps {
  data: LinearChartSeries[];
  isLoading?: boolean;
  width?: number;
  height?: number;
  xAxisLabel?: string;
  yAxisLabel?: string;
  customLoadingMessage?: string;
  customNoDataMessage?: string;
}

const LineChart: React.FC<LineChartProps> = ({
  data,
  xAxisLabel = "",
  yAxisLabel = "",
  isLoading = false,
  width = undefined,
  height = 350,
  customLoadingMessage = "Loading data ...",
  customNoDataMessage,
}) => {
  const { t } = useTranslation();
  const xAxisYears = [];
  for (let i = 0; i < data[0].data.length; i++) {
    xAxisYears.push(i);
  }

  const formattedDataSet = (data?.[0]?.data ?? []).map((_, index) => {
    const entry: any = { label: xAxisLabel };
    data.forEach((item) => {
      entry[item.label] = item.data[index];
    });

    return entry;
  });

  return (
    <MUILineChart
      // improves performance but may disable some features keep it for now if it is an issue remove it
      disableAxisListener
      xAxis={[
        {
          data: xAxisYears,
          label: xAxisLabel,
          disableTicks: true,
          labelStyle: { fontSize: 26, fontWeight: "bold" },
        },
      ]}
      dataset={formattedDataSet}
      series={data.map((item) => ({
        label: item.label,
        dataKey: item.label,
        color: item.color,
      }))}
      yAxis={[
        {
          valueFormatter: (value: number) => {
            return value >= 1000 ? `$${value / 1000}K` : `$${value}`; // Format to 1K, 2K, etc.
          },
          label: yAxisLabel,
          disableLine: true,
          disableTicks: true,
        },
      ]}
      height={height}
      width={width}
      slotProps={{
        loadingOverlay: { message: customLoadingMessage },
        noDataOverlay: { message: customNoDataMessage ?? t("ui.no_data") },
        legend: {
          direction: "column",
          position: { horizontal: "left", vertical: "top" },
          padding: { left: 70, top: 15 },
          itemMarkWidth: 12,
          itemMarkHeight: 12,
        },
      }}
      loading={isLoading}
      sx={{
        [`& .${legendClasses.mark}`]: {
          ry: 10,
        },
      }}
    />
  );
};

export default LineChart;
